import { queryOptions } from "@tanstack/react-query";
import {
  getProgramDayFn,
  getProgramFn,
  getProgramParticipantCountFn,
  getWeekDaysFn,
  listAllProgramsFn,
  listProgramsFn,
} from "./queries.functions";

export {
  getProgramDayFn,
  getProgramFn,
  getProgramParticipantCountFn,
  getWeekDaysFn,
  listAllProgramsFn,
  listProgramsFn,
};

// PUBLIC/AUTH ENDPOINTS

export const listProgramsOptions = () =>
  queryOptions({
    queryKey: ["listPrograms"],
    queryFn: () => listProgramsFn(),
    staleTime: 1000 * 60 * 5,
  });

export const getProgramOptions = (programId: string) =>
  queryOptions({
    queryKey: ["program", programId],
    queryFn: () => getProgramFn({ data: { programId } }),
  });

export const getProgramDayOptions = (dayId: string) =>
  queryOptions({
    queryKey: ["programDay", dayId],
    queryFn: () => getProgramDayFn({ data: { dayId } }),
  });

// Get week days
export const getWeekDaysOptions = (programId: string, weekNumber: number) =>
  queryOptions({
    queryKey: ["weekDays", programId, weekNumber],
    queryFn: () => getWeekDaysFn({ data: { programId, weekNumber } }),
  });

// ADMIN ENDPOINTS

export const listAllProgramsOptions = () =>
  queryOptions({
    queryKey: ["listAllPrograms"],
    queryFn: () => listAllProgramsFn(),
  });

export const getProgramParticipantCountOptions = (programId: string) =>
  queryOptions({
    queryKey: ["program-participant-count", programId],
    queryFn: () => getProgramParticipantCountFn({ data: { programId } }),
  });
